import { JSX } from 'preact/compat'

type Props = {
  children: JSX.Element
}

const RegistrationPage = (props: Props) => (
  <div className="wf_reset wf_container wf_registrationpage_wrapper">
    <div className="wf_reset wf_box wf_registrationpage_box">{props.children}</div>
  </div>
)

export default RegistrationPage
